
import { createContext } from 'react';

export const SaleCampaignContext = createContext();
